module.exports = __webpack_public_path__ + "img/blacklogo.61aa47e0.png";